<form-control
  [group]="formGroup"
  [config]="toggleConfig"
  [control]="formGroup.get(config.prop)"
>
</form-control>

@if (showDependents) {
  <div @fade>
    <form-group
      [ngClass]="{ 'conditional-grid': config.isGrid }"
      [form]="formGroup"
      [configs]="config.controls"
    >
    </form-group>
  </div>
}
